module.exports = __webpack_public_path__ + "img/attachment.5f67a95c.svg";